import {
  Box,
  Text,
  Grid,
  GridItem,
  Badge,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';

const FileSummarySection = ({
  uploadedQuote,
  uploadedMVR,
  uploadedAutoplus,
  hasQuote,
  hasMVR,
  hasDriverReport,
}: {
  uploadedQuote: string | null;
  uploadedMVR: string[];
  uploadedAutoplus: string[];
  hasQuote: boolean;
  hasMVR: boolean;
  hasDriverReport: boolean;
}) => {
  const summaryBoxBg = useColorModeValue('gray.50', 'whiteAlpha.50');

  return (
    <Grid templateColumns={`repeat(${3}, 1fr)`} gap="12px">
      {hasQuote && (
        <GridItem>
          <Box p="10px" bg={summaryBoxBg} borderRadius="md">
            <Text fontWeight="500" fontSize="sm" color="gray.600">
              Quote{' '}
              <Badge colorScheme="green" fontSize="xs" ml={2}>
                1 file
              </Badge>
            </Text>
            {uploadedQuote ? (
              <VStack align="flex-start" spacing="4px" mt={2}>
                <Text fontSize="xs">{uploadedQuote}</Text>
              </VStack>
            ) : (
              <Text fontSize="xs" color="gray.500">
                No files
              </Text>
            )}
          </Box>
        </GridItem>
      )}

      {hasMVR && (
        <GridItem>
          <Box p="10px" bg={summaryBoxBg} borderRadius="md">
            <Text fontWeight="500" fontSize="sm" color="gray.600">
              MVR{' '}
              <Badge colorScheme="green" fontSize="xs" ml={2}>
                {uploadedMVR.length} files
              </Badge>
            </Text>
            {uploadedMVR.length > 0 ? (
              <VStack align="flex-start" spacing="4px">
                <Box w="100%">
                  {uploadedMVR.map((name, idx) => (
                    <Text key={name} fontSize="xs" mt={2}>
                      <strong>{idx + 1}.</strong> {name}
                    </Text>
                  ))}
                </Box>
              </VStack>
            ) : (
              <Text fontSize="xs" color="gray.500">
                No files
              </Text>
            )}
          </Box>
        </GridItem>
      )}

      {hasDriverReport && (
        <GridItem>
          <Box p="10px" bg={summaryBoxBg} borderRadius="md">
            <Text fontWeight="500" fontSize="sm" color="gray.600">
              AutoPlus/DASH{' '}
              <Badge colorScheme="green" fontSize="xs" ml={2}>
                {uploadedAutoplus.length} files
              </Badge>
            </Text>
            {uploadedAutoplus.length > 0 ? (
              <VStack align="flex-start" spacing="4px">
                <Box w="100%">
                  {uploadedAutoplus.map((name, idx) => (
                    <Text key={name} fontSize="xs" mt={2}>
                      <strong>{idx + 1}.</strong> {name}
                    </Text>
                  ))}
                </Box>
              </VStack>
            ) : (
              <Text fontSize="xs" color="gray.500">
                No files
              </Text>
            )}
          </Box>
        </GridItem>
      )}
    </Grid>
  );
};

export default FileSummarySection;
